/** CDN para resolver URLs de media. Azure Blob requiere container/path en la URL. */
export const CDN_BASE_URL = 'https://aipeces-media-a4hsbvf5gff3b6b0.z02.azurefd.net';
const KNOWN_CONTAINERS = ['capture-media', 'profile-images', 'users', 'moment-media'];

/**
 * Fotos de captura en el contenedor `capture-media`, con prefijo `users/{userId}/`.
 * No son el contenedor de primer nivel `users/`.
 */
const CAPTURE_USERS_PATH = /^users\/[0-9a-f-]{36}\//i;

/**
 * Resuelve path/URL a URL completa del CDN.
 * Si el path es solo un filename (ej: avatar-123.jpg) o no incluye container,
 * se añade defaultContainer para evitar 404 "blob does not exist".
 */
export function resolveMediaUrl(
    pathOrUrl: string | null | undefined,
    defaultContainer: 'capture-media' | 'profile-images' = 'capture-media'
): string | null {
    if (!pathOrUrl || typeof pathOrUrl !== 'string') return null;
    const t = pathOrUrl.trim();
    if (!t) return null;
    if (t.startsWith('http://') || t.startsWith('https://')) return t;
    if (t.startsWith('data:')) return t;
    let path = t.startsWith('/') ? t.slice(1) : t;
    if (defaultContainer === 'capture-media' && CAPTURE_USERS_PATH.test(path)) {
        path = `capture-media/${path}`;
    }
    const hasContainer = KNOWN_CONTAINERS.some((c) => path.startsWith(`${c}/`));
    const fullPath = hasContainer ? path : `${defaultContainer}/${path}`;
    return `${CDN_BASE_URL}/${fullPath}`;
}
